// extracted by mini-css-extract-plugin
module.exports = {"root":"detail-info-list-item_root__Y0jvL","title":"detail-info-list-item_title__ZABQQ","value":"detail-info-list-item_value__1Im6D"};